import React from 'react';

const View = () => {
    return (
        <div>
            View photo
        </div>
    );
};

export default View;